module.exports = __webpack_public_path__ + "static/media/arts_10.e21dd135.jpg";